(function (algolia, instantsearch) {
    if (!algolia.full_results || !algolia.config.instant_search_enabled) return;

    var _ = algolia._,
        $ = algolia.jQuery;

    algolia.config.results_selector += ', .algolia-shopify-instantsearch';

    var $hiding = $('<style>' + algolia.config.results_selector + ' { visibility: hidden }</style>');
    $hiding.appendTo($('head'));

    var instant = algolia.instantsearch = {
        colors: algolia.config.colors,
        facets: {
            hidden: algolia.hiddenFacets,
            shown: algolia.shownFacets,
            list: algolia.facets,
            widgets: algolia.facetsWidgets
        },
        hitsPerPage: algolia.config.products_full_results_hits_per_page,
        poweredBy: algolia.config.powered_by,
        search: instantsearch({
            appId: algolia.config.app_id,
            apiKey: algolia.config.search_api_key,
            indexName: '' + algolia.config.index_prefix + 'products',
            urlSync: {}

        }),
        selector: algolia.config.results_selector + ', .algolia-shopify-instantsearch',
        sortOrders: algolia.sortOrders,
        storeName: algolia.storeName,
        templates: {
            currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
            empty: algolia.getTemplate('instant_search_no_result'),
            page: algolia.compileTemplate('instant_search'),
            product: algolia.getTemplate('instant_search_product'),
            stats: algolia.getTemplate('instant_search_stats'),
            style: algolia.compileTemplate('instant_search.css')
        }
    };

    if (instant.poweredBy) {

    }

    function readjust() {
        var width = instant.$results.outerWidth();

        var suffix = 'lg';
        if (width < 400) suffix = 'xs';
        else if (width < 800) suffix = 'sm';
        else if (width < 1200) suffix = 'md';

        instant.$results
            .removeClass('ais-results-size-xs')
            .removeClass('ais-results-size-sm')
            .removeClass('ais-results-size-md')
            .removeClass('ais-results-size-lg')
            .addClass('ais-results-size-' + suffix);
    }

    // Bind helpers
    _.forEach(algolia.helpers, function (helper, name) {
        instant.search.templatesConfig.helpers[name] = helper;
    });
    instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

    algolia.appendStyle(algolia.render(instant.templates.style, {
        colors: instant.colors
    }));

    $(document).ready(function () {
        instant.$results = $(instant.selector);

        instant.$results.html(algolia.render(instant.templates.page, {
            facets: instant.facets.list,
            storeName: instant.storeName
        }));

        readjust();

        $(window).resize(function () {
            readjust();
        });

        // Mobile facets display
        instant.search.addWidget({
            init: function (opts) {
                var $button = $('.ais-facets-button');
                var $facets = $('.ais-facets');
                $button.on('click', function () {

                    if ($facets.hasClass('ais-facets__shown')) {
                        /* TODO: nyelvibe */
                        $('.ais-overlay').remove();
                        $('body').css('overflow-y', 'auto');
                        $facets.removeClass('ais-facets__shown');
                    } else {
                        /* TODO: nyelvibe */
                        $('.ais-block').append('<div class="ais-overlay"></div>');
                        $('body').css('overflow-y', 'hidden');
                        $facets.addClass('ais-facets__shown');
                    }
                });
                $(document).on('click',function(e)
                {
                    var button_is_target = $button.is(e.target) || $button.find('img').is(e.target);

                    if (!$facets.is(e.target) && $facets.has(e.target).length === 0 && !button_is_target)
                    {
                        $('.ais-overlay').remove();
                        $('body').css('overflow-y', 'auto');
                        $facets.removeClass('ais-facets__shown');
                    }
                });
            }
        });

        // Highlight tags
        instant.search.addWidget({
            init: function (opts) {
                var helper = opts.helper;
                var page = helper.getPage();
                helper.setQueryParameter('highlightPreTag', '<span class="ais-highlight">');
                helper.setQueryParameter('highlightPostTag', '</span>');
                helper.setQueryParameter('distinct', true);
                helper.setPage(page);
            }
        });

        // Search input
        instant.search.addWidget(
            instantsearch.widgets.searchBox({
                container: '.ais-search-box-container',
                /* TODO: merge többibe is*/
                placeholder: `Here you can enter the product name, color, taste, ingredients ...`,
                poweredBy: false
            })
        );
        instant.search.addWidget(
            instantsearch.widgets.analytics({
                pushFunction: function (formattedParameters, state, results) {
                    // Google Analytics
                    window.dataLayer.push({
                        'event': 'Site Search',
                        'searchQuery':state.query,
                        'searchFormattedParameters':formattedParameters,
                        'searchNumberOfHits':results.nbHits
                    });

                    //window.ga('set', 'page', '/search/query/?query=' + state.query + '&' + formattedParameters + '&numberOfHits=' + results.nbHits);
                    //window.ga('send', 'pageView');

                    //ScarabQueue.push(['searchTerm', state.query]);
                    //ScarabQueue.push(['go']);

                    // GTM
                    // dataLayer.push({'event': 'search', 'Search Query': state.query, 'Facet Parameters': formattedParameters, 'Number of Hits': results.nbHits});

                    // Segment.io
                    // analytics.page( '[SEGMENT] instantsearch', { path: '/instantsearch/?query=' + state.query + '&' + formattedParameters });

                    // Kissmetrics
                    // var objParams = JSON.parse('{"' + decodeURI(formattedParameters.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
                    // var arrParams = $.map(objParams, function(value, index) {
                    //   return [value];
                    // });
                    //
                    // _kmq.push(['record', '[KM] Viewed Result page', {
                    //   'Query': state.query ,
                    //   'Number of Hits': results.nbHits,
                    //   'Search Params': arrParams
                    // }]);

                    // any other analytics service
                }
            })
        );

        // Constructor tracking attributumok (beacon)
        instant.search.addWidget({
            render: function (opts) {
                var results = opts.results;
                var state = opts.state;

                $('.ais-results-title')
                    .attr('data-cnstrc-search', '')
                    .attr('data-cnstrc-search-term', state.query || '')
                    .attr('data-cnstrc-num-results', results.nbHits)
                    .attr('data-cnstrc-result-page', results.page + 1);
            }
        });

        // Logo & clear
        instant.search.addWidget({
            init: function (opts) {
                if (!instant.poweredBy) {
                    $('.ais-algolia-icon').hide();
                }
                $('.ais-clear-input-icon').on('click', function () {
                    opts.helper.setQuery('').search();
                    $('.ais-search-box--input').val('').focus();
                });
            },
            render: function (opts) {
                if (!opts.state.query) {
                    if (instant.poweredBy) {
                        $('.ais-algolia-icon').show();
                    }
                    $('.ais-clear-input-icon').hide();
                } else {
                    $('.ais-clear-input-icon').show();
                    $('.ais-algolia-icon').hide();
                }
            }
        });

        // Stats
        instant.search.addWidget(
            instantsearch.widgets.stats({
                container: '.ais-stats-container',
                templates: {
                    body: instant.templates.stats,
                },
                transformData: {
                    body: function (data) {
                        data.processingTimeS = data.processingTimeMS / 1000;
                        data.start = data.page * data.hitsPerPage + 1;
                        data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
                        return data;
                    }
                }
            })
        );

        // Sort orders
        instant.search.addWidget(
            instantsearch.widgets.sortBySelector({
                container: '.ais-sort-orders-container',
                indices: instant.sortOrders
            })
        );

        // Change display
        instant.search.addWidget({
            init: function (opts) {
                $('.ais-search-header').on('click', '.ais-change-display-block', function () {
                    changeToBlock();
                });
                $('.ais-search-header').on('click', '.ais-change-display-list', function () {
                    changeToList();
                });
            }
        });

        function changeToBlock() {
            Cookies.set('display', 'block');
            $('.ais-change-display-block').addClass('ais-change-display-selected').attr('style', 'display: none !important;');
            $('.ais-change-display-list').removeClass('ais-change-display-selected').attr('style', 'display: block !important;');
            $('.ais-hits--item > .product').removeClass('large--one-half small--one-whole').addClass('large--one-third small--one-whole');
            $('.ais-results-as-list').removeClass('ais-results-as-list').addClass('ais-results-as-block');
        }

        function changeToList() {
            Cookies.set('display', 'list');
            $('.ais-change-display-list').addClass('ais-change-display-selected').attr('style', 'display: none !important;');
            $('.ais-change-display-block').removeClass('ais-change-display-selected').attr('style', 'display: block !important;');
            $('.ais-hits--item > .product').removeClass('large--one-third small--one-half').addClass('large--one-half small--one-whole');
            $('.ais-results-as-block').removeClass('ais-results-as-block').addClass('ais-results-as-list');
        }


        // Hidden facets
        var list = _.map(instant.facets.hidden, function (facet) {
            return facet.name;
        });
        instant.search.addWidget({
            getConfiguration: function () {
                return {
                    facets: list,
                    disjunctiveFacets: list
                };
            },
            init: function () {
            }
        });

        // Current refined values
        var attributes = _.map(instant.facets.shown, function (facet) {
            return {
                name: facet.name,
                label: facet.title
            }
        });


        // instant.search.addWidget(
        //     instantsearch.widgets.currentRefinedValues({
        //         container: '.ais-current-refined-values-container',
        //         cssClasses: {
        //             root: 'ais-facet',
        //             header: 'ais-facet--header',
        //             body: 'ais-facet--body'
        //         },
        //         templates: {
        //             header: `Selected filters`,
        //             item: instant.templates.currentItem,
        //             clearAll: `Delete filters`,
        //         },
        //         onlyListedAttributes: true,
        //         attributes: attributes
        //     })
        // );

        // Facets
        _.forEach(instant.facets.widgets, function (widget) {
            instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
        });

        // Hits
        instant.search.addWidget(
            instantsearch.widgets.hits({
                container: '.ais-hits-container',
                hitsPerPage: instant.hitsPerPage,
                templates: {
                    empty: instant.templates.empty,
                    item: instant.templates.product
                },
                transformData: {
                    item: function (product) {

                        var is_package = false;

                        if ('new_pack' === product.template_suffix || 'layout-builder-pack' === product.template_suffix) {
                            is_package = true;
                        }

                        product.is_package = is_package;

                        product.can_order = (
                            product.inventory_management !== 'shopify' ||
                            product.inventory_policy === 'continue' ||
                            product.inventory_quantity > 0
                        );
                        return product;
                    }
                }
            })
        );

        // Redirect to product on click
        instant.search.addWidget({
            init: function (opts) {
                $('.ais-hits-container').on('click', '.img-holder, .ais-hit--title', function (e) {
                    let $this = $(this),
                        product_container = $(this).closest('.product'),
                        handle = product_container.attr('data-handle'),
                        variant_id = product_container.attr('data-variant-id');

                    window.location.href = '/products/' + handle + '?variant=' + variant_id;

                });

                $('.ais-hits-container').on('click', '.product a', function (e) {
                    e.stopPropagation();
                });

                $('.ais-hits-container').on('click', '.product span', function (e) {
                    e.stopPropagation();
                });
            }
        });

        // No result actions
        instant.search.addWidget({
            init: function (opts) {
                $('.ais-facets').on('click', '.ais-filter-clear--link', function () {
                    var helper = opts.helper;
                    helper.clearTags();
                    _.forEach(instant.facets.list, function (facet) {
                        helper.clearRefinements(facet.name);
                    });
                    helper.search();
                });

                $('.ais-hits-container').on('click', '.ais-hit-empty--clear-input', function () {
                    opts.helper.setQuery('').search();
                    $('.ais-search-box--input').val('').focus();
                });
            }
        });

        // Pagination
        instant.search.addWidget(
            instantsearch.widgets.pagination({
                container: '.ais-pagination-container',
                padding: 2,
                maxPages: 20,
                showFirst: false,
                showLast: false,
                scrollTo: '#algolia-search',
                labels: {
                    next: '<img src="//cdn.shopify.com/s/files/1/1758/3403/t/6/assets/pagination-next.svg?v=15688787203744031465" class="icon-left-open-big" alt="Előző">',
                    previous: '<img src="//cdn.shopify.com/s/files/1/1758/3403/t/6/assets/pagination-next.svg?v=15688787203744031465" class="icon-left-open-big" alt="Következő">'
                }
            })
        );
        /*
         instant.search.addWidget(
         instantsearch.widgets.infiniteHits({
         container: '.ais-hits-container',
         showMoreLabel:'Továbbiak betöltése',
         templates: {
         empty: instant.templates.empty,
         item: instant.templates.product
         },
         escapeHits: true,
         })
         );

         */

        const review_provider_dom = document.getElementById('review_provider');
        const review_provider = review_provider_dom?.dataset.reviewProvider;

        // Main
        instant.search.start();
        instant.search.on('render', function () {
            if (Cookies.get('display') === 'list') {
                changeToList();
            }

            if ('judgeme' === review_provider) {
                judgeme.badge();
                judgeme.customizeBadges();
            }

            ajaxCart.init({
                formSelector: '.AddToCartForm',
                cartContainer: '#CartContainer',
                addToCartSelector: '#AddToCart',
                cartCountSelector: null,
                cartCostSelector: '#CartCost',
                moneyFormat: null
            });

            // A constructor.recommender.liquid 'empty_search_pod_id' widgetje
            // (lasd templates/search.liquid) erre az esemenyre var, ha 0 talalat
            // van - fuggetlenul attol, hogy Algolia vagy Constructor futott le.
            var lastResults = algolia.instantsearch.search.helper.lastResults;
            if (lastResults && lastResults.nbHits === 0) {
                document.dispatchEvent(new CustomEvent('cnstrc:empty-search', {
                    detail: { term: lastResults.query || '' }
                }));
            }

            $('.ais-selected-facets').html('');
            $.each(algolia.instantsearch.search.helper.lastResults._state.facetsRefinements, function (facet, refinements) {
                $.each(refinements, function (key, refinement) {
                    $('.ais-selected-facets').append(`<div data-facet="${facet}" data-value="${refinement}" class="ais-selected-facets--item">${refinement}<img src="//shopdev.biotechusa.pl/cdn/shop/t/2/assets/facet-close.svg?v=85826651194294428601788952014" alt="Close"></div>`)
                })
            })
            $.each(algolia.instantsearch.search.helper.lastResults._state.disjunctiveFacetsRefinements, function (facet, refinements) {
                $.each(refinements, function (key, refinement) {
                    $('.ais-selected-facets').append(`<div data-facet="${facet}" data-value="${refinement}" class="ais-selected-facets--item">${refinement}<img src="//shopdev.biotechusa.pl/cdn/shop/t/2/assets/facet-close.svg?v=85826651194294428601788952014" alt="Close"></div>`)
                })
            })

            $('.ais-selected-facets--item').on('click', function () {
                var facet = $(this).data('facet');
                var value = $(this).data('value');

                algolia.instantsearch.search.helper.removeFacetRefinement(facet, value);
                algolia.instantsearch.search.helper.search();
            })

            translateJudgemeBadge($('.ais-hits-container'));
            triggerCustomEvent('ais-render');
        });
        $hiding.remove();
    });
}(algoliaShopify, instantsearch));
